import {Injectable,} from '@angular/core';
import {HttpClient,} from '@angular/common/http';
import {HanyoMasterVO,} from '@models/index';
import {WindowService,} from '..';
import {Observable, tap,} from 'rxjs';

/**
 * マスターキャッシュサービス
 */
@Injectable({
  providedIn: 'root',
})
export class HanyoMasterService {
  hanyoMasterListByShbtCode: Map<string, HanyoMasterVO[]> = new Map<string, HanyoMasterVO[]>();
  hanyoMasterByShbtAndHyoujiCode: Map<string, HanyoMasterVO> = new Map<string, HanyoMasterVO>();

  constructor(
    private http: HttpClient,
    private windowService: WindowService
  ) {
  }

  /**
   * [一般開発者利用不可]
   * 汎用マスタ情報取得処理（HTTPリクエスト）.
   */
  getAndSaveHanyoMaster() :Observable<HanyoMasterVO[]> {
    // 汎用マスタ情報取得処理を呼ぶ.
    return this.http.get<HanyoMasterVO[]>('/hanyo-master').pipe(
    tap((hanyoMasterList: HanyoMasterVO[]) => {

        // 汎用マスタ登録処理
        this.saveHanyoMaster(hanyoMasterList);
      }));
  }

  /**
   * [一般開発者利用不可]
   * 汎用マスタ登録処理。
   * 種別コードで汎用マスタリストを取得するためのMapの作成と種別コード_表示コードで汎用マスタを
   * 取得するMapの作成を行う
   * @param hanyoMstListObj 汎用マスターレコードオブジェクト
   * @private
   */
  private saveHanyoMaster(hanyoMstListObj: object): void {
    // getからの戻り値がオブジェクト型として読み込みがされるため、引数の型はObjectで定義
    const hanyoMstList: HanyoMasterVO[] = Object.values(hanyoMstListObj)[0]
    this.setHanyoMaster(hanyoMstList);

    // session保持
    this.windowService.setItemToLocalStorage('hanyoMaster', hanyoMstList);
  }

  /**
   * [一般開発者利用不可]
   * 汎用マスタ設定処理。
   * 種別コード、表示コードでの取得用にMapの作成を行う
   * @param hanyoMstList 汎用マスターレコード
   * @private
   */
   private setHanyoMaster(hanyoMstList: HanyoMasterVO[]): void {

    this.hanyoMasterListByShbtCode = new Map<string, HanyoMasterVO[]>();
    this.hanyoMasterByShbtAndHyoujiCode = new Map<string, HanyoMasterVO>();

    // key:カテゴリー名、value:CodeMaster[]となるMapを作成.
    hanyoMstList.forEach(hanyoMst => {
      // hanyoMasterListByShbtCodeに種別コードが格納されている場合、マップからデータを取得し、未格納の場合新規リストを作成する.
      const hanyoMasterList = this.hanyoMasterListByShbtCode.has(hanyoMst.shbtCode) ?
        <HanyoMasterVO[]>this.hanyoMasterListByShbtCode.get(hanyoMst.shbtCode) : [];
      hanyoMasterList.push(hanyoMst);
      this.hanyoMasterListByShbtCode.set(hanyoMst.shbtCode, hanyoMasterList);
      // 種別コード_表示コードをキーに汎用マスターレコードを登録
      this.hanyoMasterByShbtAndHyoujiCode.set(hanyoMst.shbtCode + '_' + hanyoMst.hyoujiCode, hanyoMst);
    });
  }

  /**
   * [一般開発者利用不可]
   * 汎用マスタ再取得登録処理。
   * Mapが未作成の場合、Sessionから情報取得しMapを再作成する
   * @private
   */
   private reSetHanyoMaster(): void {
    const hanyoMaster = this.windowService.getItemFromLocalStorage<HanyoMasterVO[]>('hanyoMaster');
    if(hanyoMaster){
      this.setHanyoMaster(hanyoMaster);
    }
  }

  /**
   * [一般開発者利用可]
   * 種別コードを元に汎用マスタのリストを取得する
   * @param shbtCode 種別コード
   */
  getHanyoMasterListByShbtCode(shbtCode: string): HanyoMasterVO[] | undefined {
    if(this.hanyoMasterListByShbtCode.size === 0){
      // 対象データなしの場合、Mapを再作成
      this.reSetHanyoMaster();
    }

    return this.hanyoMasterListByShbtCode.get(shbtCode);
  }

  /**
   * [一般開発者利用可]
   * 種別コードと表示コードを元に汎用マスタのレコード(1件)を取得する
   * @param shbtCode 種別コード
   * @param hyoujiCode 表示コード
   */
  getHanyoMasterItem(shbtCode: string, hyoujiCode: string): HanyoMasterVO | undefined {
    if(this.hanyoMasterByShbtAndHyoujiCode.size === 0){
      // 対象データなしの場合、Mapを再作成
      this.reSetHanyoMaster();
    }

    return this.hanyoMasterByShbtAndHyoujiCode.get(shbtCode + '_' + hyoujiCode);
  }

}
